// extracted by mini-css-extract-plugin
export default {"createGroupForm":"CreateGroupForm_createGroupForm__Ce5Og","actions":"CreateGroupForm_actions__rMUU9","header":"CreateGroupForm_header__HS4Ox"};